import moment from 'moment';
import { fetchSinToken } from '../../helpers/fetch';
import { handleErrorApi } from '../../helpers/randoms';
import { types } from '../../types/types';
import { finishSpinner, startSpinner } from '../ui/spinner';
import { startAlerta } from '../ui/alertas';


export const clearDataAfiliado = () => {
  return { type: types.setDataAfiliadoHCE };
};

export const clearTurnoTeleconsulta = () => {
  return { type: types.turnoTeleconsultaSucess };
};

export const clearTurnosProximos = () => {
  return { type: types.turnosProximosAfiliadoSucess };
};
export const FetchDataAfiliado = (dni) => async (dispatch) => {
  try {
    const response = await fetchSinToken(
      `HCE/TraerInfoAfiliado/${dni}`,
    );
    const body = await response.json();

    if (response.ok) {
      dispatch({
        type: types.setDataAfiliadoHCE,
        payload: body[0],
      });
    } else {
      throw body;
    }
  } catch (error) {
    handleErrorApi(
      dispatch,
      error,
      'Error al cargar la informacion del afiliado.',
      'Ha ocurrido un error. Intente Nuevamente',
    );
  }
};

export const traerTurnoTeleconsulta = (dni, fecha, idTipoTurno, setRedirect, connectionId) => async (dispatch) => {
  let fechaModif = fecha instanceof Date ? moment(fecha).format() : '';
  try {
    const response = await fetchSinToken(
      `HCE/TraerTurnoTeleconsulta/${dni},${fechaModif},${idTipoTurno},${connectionId}`,
    );
    const body = await response.json();

    if (response.ok) {
      dispatch({
        type: types.turnoTeleconsultaSucess,
        payload: body,
      });
      setRedirect(true)
    } else {
      throw body;
    }
  } catch (error) {
    handleErrorApi(
      dispatch,
      error,
      'Error al cargar la informacion del afiliado.',
      'Ha ocurrido un error. Intente Nuevamente',
    );
  }
};

export const traerTurnosProximos = (dni, fecha) => async (dispatch) => {
  let fechaModif = fecha instanceof Date ? moment(fecha).format() : '';
  try {
    const response = await fetchSinToken(
      `HCE/TraerTurnosProximos/${dni},${fechaModif}`,
    );
    const body = await response.json();

    if (response.ok) {
      dispatch({
        type: types.turnosProximosAfiliadoSucess,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    handleErrorApi(
      dispatch,
      error,
      'Error al cargar los turnos proximos.',
      'Ha ocurrido un error. Intente Nuevamente',
    );
  }
};

export const ingresoPacienteSala =
  (datos) => async (dispatch) => {
    try {
      dispatch(startSpinner());

      const response = await fetchSinToken(
        `HCE/insertarPacienteSala`,
        datos,
        'POST',
      );
      const body = await response.json();

      if (response.ok) {
        dispatch(
          startAlerta(
            'Ingresado en sala',
            'success',
            'Comando Exitoso',
          ),
        );
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        'Error al modificar el estado.',
        'Ha ocurrido un error. Intente nuevamente',
      );
    }
  };

export const deslogueoPacienteSala =
  (datos) => async (dispatch) => {
    try {
      dispatch(startSpinner());

      const response = await fetchSinToken(
        `HCE/DeslogueoPacienteSala
        `,
        datos,
        'POST',
      );
      const body = await response.json();

      if (response.ok) {
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        'Error al modificar el estado.',
        'Ha ocurrido un error. Intente nuevamente',
      );
    }
  };

export const IniciarChatAfiliado =
  (datos) => async (dispatch) => {
    try {
      dispatch(startSpinner());

      const response = await fetchSinToken(
        `HCE/IniciarChatPaciente
        `,
        datos,
        'POST',
      );
      const body = await response.json();

      if (response.ok) {
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        'Error al modificar el estado.',
        'Ha ocurrido un error. Intente nuevamente',
      );
    }
  };


